import { render, staticRenderFns } from "./FixedPatrolInspection.vue?vue&type=template&id=2b196314&"
import script from "./FixedPatrolInspection.vue?vue&type=script&lang=js&"
export * from "./FixedPatrolInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports